export default {
  user: null,
  empresaPrincipal: null,
  grupoPrincipal: null,
  prefix: null,
  papel: null
}
